import { render, staticRenderFns } from "./CategoryMenuItem.vue?vue&type=template&id=06614706&scoped=true&"
import script from "./CategoryMenuItem.vue?vue&type=script&lang=ts&"
export * from "./CategoryMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryMenuItem.vue?vue&type=style&index=0&id=06614706&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06614706",
  null
  
)

export default component.exports